import axios from "axios";
import { ENDPOINTS } from "./endpoints";

export const getAdminDashboardSummary = async () => {
  try {
    const response = await axios.get(ENDPOINTS.DASHBOARD.GET_ADMIN_SUMMARY);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getTeacherDashboardSummary = async () => {
  try {
    const response = await axios.get(ENDPOINTS.DASHBOARD.GET_TEACHER_SUMMARY);
    return response;
  } catch (error) {
    throw error;
  }
};
